import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { TLCEvents } from "../../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { ApplicationData } from "../../ApplicationData";
import { LS2PacSearchDatabaseManager } from "../../managers/SearchDatabaseManager";
import { PacSearchClientManager } from "../Searching/PacSearchClientManager";
import { LS2PAC_Utils } from "../../utils/Utils";

export class TitlesSearchClientManager extends PacSearchClientManager {
  constructor(options) {
	super(options);
    this.originalPageSize = options.pageSize;
    this.readingLevelFilters = null;
    
    this.addExtraListeners();
  }
  getSearchParams() {
    return {
      searchTerm: LS2PAC_Utils.getQualifiedSearchTerm(
        this.searchTermInfo.value,
        this.searchTermInfo.type
      ),
      startIndex: this.currentPage * this.pageSize,
      hitsPerPage: this.pageSize,
      facetFilters: this.facetFilters,
      branchFilters: this.getBranchFilters(),
      sortCriteria: this.sortingData.sortKey,
      targetAudience: "",
      addToHistory: this.extraDataToPassBack.isAdvanced === true ? false : true,
      dbCodes: [],
      audienceCharacteristicsFilters: this.audience,
      readingLevelFilters: this.readingLevelFilters,
    };
  }
  addExtraListeners() {
    var _this = this;

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.resetPageCache(true);
        if (_this.searchTermInfo) {
          _this.searchTermInfo.value = "";
        }
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onHome,
      function (event) {
        _this.resetPageCache(true);
        if (_this.searchTermInfo) {
          _this.searchTermInfo.value = "";
        }
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onChangeBranchLimits,
      function (event) {
        if (_this.hasResults === true) {
          _this.resetPageCache(true);
          _this.fireSearch(event);
          _this.addHistory(event);
        }
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onAddFacetFilterToResults,
      function (event) {
        _this.facetFilters.push(event.facetFilter);
        _this.resetPageCache(false);
        _this.fireSearch(event);
        _this.addHistory(event);
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRemoveFacetFilter,
      function (event) {
        _this.facetFilters.splice(event.index, 1);
        _this.resetPageCache(false);
        _this.fireSearch(event);
        _this.addHistory(event);
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onResetReadingLevelFilter,
      function (event) {
        _this.readingLevelFilters = null;
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetSpellingSuggestions,
      function (event) {
        _this.getSearchSpellingSuggestions(event);
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetCurrentSearch,
      function (event) {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onGetCurrentSearchResponse,
          { currentSearch: _this.getSearchParams() }
        );
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onSetAudience,
      function (event) {
        _this.audience = event.audience;
        if (event.doSearch) {
          _this.resetPageCache(false);
          _this.fireSearch(event);
          _this.addHistory(event);
        }
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetAudience,
      function (event) {
        TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onGetAudienceResponse, {
          audience: _this.audience,
        });
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onChangeResultsView,
      function (event) {
        if (_this.searchTermInfo.value != "") {
          _this.pageSize = _this.originalPageSize;

          _this.resetPageCache(false);
          _this.fireSearch(event);
          _this.addHistory(event);
        }
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onFireAdvancedSearch,
      function (event) {
        _this.extraDataToPassBack.isAdvanced = true;
        _this.readingLevelFilters = event.readingLevelFilters || null;

        _this.searchTermInfo = {
          value: JSON.stringify(event.searchString),
          type: LS2PAC_CONSTANTS.searchFields.advanced,
        };

        _this.resetPageCache(true);
        _this.fireSearch(event);
        _this.addHistory(event);
      }
    );
  }
  onBeforeFireSearch(event) {
    if (!event.fromHistory) {
      this.resetPageCache(true);
    }

    // we have two different event structures that can pass through onBeforeFireSearch
    const {searchParams, sortKey, currentPage, page, branchFilters, facetFilters, databaseKey, audienceCharacteristicsFilters, readingLevelFilters} = event;
    const sort = searchParams?.sortCriteria || sortKey;
    const pageValue = currentPage ?? page;
    const branches = searchParams?.branchFilters || branchFilters;
    const facets = searchParams?.facetFilters || facetFilters;
    const audience = searchParams?.audienceCharacteristicsFilters || audienceCharacteristicsFilters;
    const readingLevels = searchParams?.readingLevelFilters || readingLevelFilters;

    this.extraDataToPassBack.isAdvanced = false;

    if (sort) {
      this.sortingData.sortKey = sort;
    }

    if (pageValue) {
      this.currentPage = pageValue;
    }

    if (branches) {
      this.branchFilters = branches;
    }

    if (facets) {
      this.facetFilters = facets;
    }

    if (!databaseKey) {
      event.databaseKey = LS2PacSearchDatabaseManager.getCurrentDatabaseKey();
    }

    if (
      audience &&
      ApplicationData.locationConfiguration.showAudienceControl()
    ) {
      this.audience = audience;
    }

    this.readingLevelFilters = readingLevels || null;

	super.onBeforeFireSearch(event);

    this.addHistory(event);
  }
  resetPageCache(clearFacets) {
    this.pages = [];
    this.hasResults = false;
    this.totalHits = 0;
    this.currentPage = 0;
    this.sortingData.sortKey = this.defaultSortKey;
    this.branchFilters = null;

    if (clearFacets) {
      this.facetFilters = [];
    }
  }
}
